import { useEffect, useState } from 'react';
import './HomeContent.css';
import LeadsSummary from '../../components/LeadsSummary/LeadsSummary';
import ClientsSummary from '../../components/ClientsSummary/ClientsSummary';
import ApplicationsSummary from '../../components/ApplicationsSummary/ApplicationsSummary';
import FormsSummary from '../../components/FormsSummary/FormsSummary';
import ProjectsSummary from '../../components/ProjectsSummary/ProjectsSummary';
import { getHomeData } from '../../utilities/api/home';
import { getServices } from '../../utilities/api/services';

export default function HomeContent({user}) {
  const [loading, setLoading] = useState(false)
  const [homeData, setHomeData] = useState(null)
  const [services, setServices] = useState([])
  const tabs = {
    ...['manager', 'admin'].includes(user.userType)&& {leads: 'Leads'},
    ...['manager', 'admin'].includes(user.userType)&& {clients: 'Clients'},
    ...['manager', 'admin'].includes(user.userType)&& {forms: 'Forms'},
    projects: 'Projects',
    ...['manager', 'admin'].includes(user.userType)&& {applications: 'Applications'},
  }
  const [activeTabIndex, setActiveTabIndex] = useState(Object.keys(tabs)[0]);

  const handleTabClick = (tab) => {
    setActiveTabIndex(tab);
  }

  const handleDropdownClick = (evt) => {
    // prevent dropdown from closing when clicked
    evt.stopPropagation()
  }

  const getHomeContent = async (user) => {
    setLoading(true)
    try {
      const data = await getHomeData(user);
      setHomeData(data)
      setLoading(false)
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const getAllServices = async () => {
    try {
      const data = await getServices()
      setServices(data)
    } catch (error) {
      console.log(error)
    }
  }

  // console.log(homeData)

  useEffect(() => {
    getHomeContent(user)
    getAllServices()
    // eslint-disable-next-line
  }, [])

  return (
    <div className='HomeContent'>
      <div className='homeContentHeadingContainer'>
        <div className='section1'>
          <div className='title'>
            Home
          </div>
        </div>
      </div>
      { loading ?
      <div className='loading'>
        <div className="spinner-border" role="status"></div>
      </div>
      :
      <div className='homeContentMainSection'>
        <div className="nav nav-pills flex-row navigation" id="v-pills-tab" role='tablist' aria-orientation="horizontal">
        {Object.keys(tabs).map((tab, index) => (
          <button key={tab} onClick={() => handleTabClick(tab)} className={`nav-link ${activeTabIndex === tab ? 'active' : ''}`} id={`${tab}Tab`} type="button">
            {tabs[tab]}
          </button>
        ))}
        </div>
        <div className="tab-content" id="v-pills-tabContent">
          {Object.keys(tabs).map((tab, index) => (
            <div key={tab} className={`tab-pane fade ${activeTabIndex === tab ? 'show active' : ''}`} id={`${tab}`} role="tabpanel" aria-labelledby={`${tab}Tab`}>
              { (homeData && user) &&
              <>
              {(tab === 'leads' && homeData.leads) &&
              <LeadsSummary leadsData={homeData.leads} handleDropdownClick={handleDropdownClick} />
              }
              {(tab === 'clients' && homeData.clients) &&
              <ClientsSummary user={user} clientsData={homeData.clients} handleDropdownClick={handleDropdownClick} />
              }
              {tab === 'forms' &&
              <FormsSummary formsData={homeData.forms} services={services} handleDropdownClick={handleDropdownClick} />
              }
              {tab === 'projects' &&
              <ProjectsSummary projectsData={homeData.projects} services={services} user={user} handleDropdownClick={handleDropdownClick} />
              }
              {tab === 'applications' &&
              <ApplicationsSummary applicationsData={homeData.applications} user={user} handleDropdownClick={handleDropdownClick} />
              }
              </>
              }
            </div>
          ))}
        </div>
      </div>
      }
    </div>
  )
}
